import { Outlet, Navigate } from 'react-router-dom';

import { useAppSelector } from 'modules/store';
import { selectUserPermissions } from 'modules/user/selector';

type Props = {
  permissionTag?: string;
  redirectPath: string;
  fallback?: boolean;
};

const PermissionProtectedRoute = ({ permissionTag, redirectPath, fallback = true }: Props) => {
  const permissions = useAppSelector(selectUserPermissions);

  if (!permissionTag) {
    return fallback ? <Outlet /> : <Navigate to={redirectPath} replace />;
  }

  const hasPermission = permissions[permissionTag as keyof typeof permissions];

  if (!hasPermission) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default PermissionProtectedRoute;
